import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompetitionEventInfoRoutingModule } from './competition-event-info-routing.module';
import { BootstrapCompetitionsInfoComponent } from './components/bootstrap-competitions-info/bootstrap-competitions-info.component';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';
import { CoreModule } from '../../library/core.module';
import { CompetitionDocumentsModule } from '../competition-documents/competition-documents.module';
import { EventInfoPanelComponent } from './components/event-info-panel/event-info-panel.component';
import { CompetitionLocationPanelComponent } from './components/competition-location-panel/competition-location-panel.component';


@NgModule({
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  declarations: [BootstrapCompetitionsInfoComponent, CompetitionLocationPanelComponent, EventInfoPanelComponent],
  imports: [
    CommonModule,
    CommonPageComponentsModule,
    CoreModule,
    CompetitionDocumentsModule,
    CompetitionEventInfoRoutingModule
  ]
})
export class CompetitionEventInfoModule { }
